export const EMPTY_VALUE = "-";

// Fields that only carry meaning once a member has (or had) a spouse.
export const SPOUSE_DEPENDENT_FIELDS = [
  "marital_date",
  "type_of_marriage",
  "is_spouse_believer",
  "is_spouse_member",
  "spouse_first_name",
  "spouse_father_name",
  "spouse_last_name",
  "spouse_phone_number",
  "spouse_date_of_birth",
  "spouse_mother_name",
  "spouse_mother_father_name",
  "spouse_mother_grand_father_name",
  "spouse_mother_date_of_birth",
  "spouse_professional_skill",
  "spouse_office_name",
  "spouse_church_name",
  "spouse_church_id",
  "spouse_religion"
];

export const isSingle = maritalStatus =>
  String(maritalStatus ?? "").toLowerCase() === "single";

// Falls back to "-" for single members and for blank values alike.
export const formatMaritalValue = (maritalStatus, value) => {
  if (isSingle(maritalStatus)) return EMPTY_VALUE;
  if (value === null || value === undefined || value === "") return EMPTY_VALUE;

  return value;
};

export const formatMaritalBoolean = (maritalStatus, value) => {
  if (isSingle(maritalStatus)) return EMPTY_VALUE;
  if (value === null || value === undefined || value === "") return EMPTY_VALUE;

  return Number(value) ? "Yes" : "No";
};
